module.exports = __webpack_public_path__ + "img/gw.1e33dcd6.svg";